import { getActivePinia } from 'pinia';

const FILTER_STORE_IDS = [
  'activeFilterStore',
  'pendingFilterStore',
  'dispatchedFilterStore',
  'pickedUpFilterStore',
  'deliveredFilterStore',
];

/**
 * Resets all initialized filter stores without importing their factory functions.
 * Iterates over Pinia's internal store map and calls resetBulkFiltersAndSort()
 * on any matching store that has already been created.
 *
 * We need to preserve sub-filters when changes statuses, however, when navigating into /manage-jobs
 * we are required to reset all sub-filters.
 */
const resetInitializedFilterStores = () => {
  const pinia = getActivePinia();
  if (!pinia) return;

  FILTER_STORE_IDS.forEach((storeId) => {
    const store = pinia._s.get(storeId);
    if (store) {
      store.resetBulkFiltersAndSort();
    }
  });
};

/**
 * Determines whether filters should be reset on navigation.
 * @param {Object} from - The route being navigated away from
 * @param {Object} to - The route being navigated to
 * @returns {boolean}
 */
const shouldResetFilters = (from, to) => {
  return (
    from.fullPath === to.fullPath ||
    !from.fullPath.includes('/manage-jobs') ||
    from.fullPath === '/manage-jobs'
  );
};

export default function manageJobsMiddleware(to, from) {
  // Redirect from base path
  if (to.fullPath === '/manage-jobs' || to.fullPath === '/manage-jobs/') {
    return navigateTo('/manage-jobs/active', { replace: true });
  }

  // Only process manage-jobs list routes
  if (!to.fullPath.includes('/manage-jobs')) {
    return;
  }

  // Reset filters when entering from outside manage-jobs
  if (shouldResetFilters(from, to)) {
    resetInitializedFilterStores();
  }
}
